(() => {
  const script = document.querySelector('script[data-ny-details-url]');
  const metadata = script?.dataset.nyDetailsUrl
    ? fetch(script.dataset.nyDetailsUrl).then(response => response.ok ? response.json() : {}).then(async data => {
      if (data.format !== 'gzip-base64') return data;
      const bytes = Uint8Array.from(atob(data.data), character => character.charCodeAt(0));
      const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
      return JSON.parse(await new Response(stream).text());
    }).catch(() => ({}))
    : Promise.resolve({});
  const clean = text => String(text || '').replace(/\s+/g,' ').trim();
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const heading = (section, text) => section.append(make('h3','ny-info-heading',text));
  const isDocument = anchor => /\.pdf(?:$|[?#])|\/amfile\/file\/download\/|\/download\/(?:file|document|attachment)/i.test(anchor.href);
  const format = async description => {
    description.dataset.nyDetailsReady = 'true';
    const source = description.cloneNode(true);
    const owner = description.closest('[data-ny-product-handle]');
    const handle = owner?.dataset.nyProductHandle;
    const records = await metadata;
    if (!description.isConnected) return;
    const record = records[handle] || {};
    const facts = new Map(Object.entries(record.specs || {}).filter(([,value]) => clean(value)));
    const features = (record.features || []).filter(value => typeof value === 'string').map(clean).filter(Boolean);
    const notes = [];
    const videos = [];
    source.querySelectorAll('.northyard-product-videos').forEach(block => {
      block.querySelectorAll('video,iframe').forEach(video => {
        videos.push({node:video.cloneNode(true),title:clean(video.parentElement?.querySelector('h3')?.textContent)});
      });
      block.remove();
    });
    source.querySelectorAll('video').forEach(video => { videos.push({node:video.cloneNode(true),title:''}); video.remove(); });
    const documents = [];
    source.querySelectorAll('a[href]').forEach(anchor => {
      if (!isDocument(anchor)) return;
      const address = new URL(anchor.href,location.href);
      if (address.origin === location.origin || address.hostname === 'cdn.shopify.com') documents.push(anchor.cloneNode(true));
      const row = anchor.closest('li');
      if (row && clean(row.textContent) === clean(anchor.textContent)) row.remove(); else anchor.remove();
    });
    source.querySelectorAll('p').forEach(paragraph => {
      if (/^Supplier availability is checked/i.test(clean(paragraph.textContent))) { notes.push(clean(paragraph.textContent)); paragraph.remove(); }
    });
    source.querySelectorAll('table').forEach(table => {
      const rows = [...table.rows];
      if (rows.length === 1 && rows[0].cells.length === 1) {
        table.replaceWith(make('p','',clean(rows[0].cells[0].textContent)));
      } else if (rows.length && rows.every(row => row.cells.length === 2 && clean(row.cells[0].textContent).length < 90)) {
        rows.forEach(row => { const label=clean(row.cells[0].textContent).replace(/:$/,''); const value=clean(row.cells[1].textContent); if(label&&value)facts.set(label,value); });
        table.remove();
      }
    });
    source.querySelectorAll('li').forEach(item => {
      if (item.querySelector('li')) return;
      const text = clean(item.textContent);
      if (!text) { item.remove(); return; }
      const parts = text.match(/^([^:]{2,65}):\s*(.+)$/);
      if (parts) facts.set(parts[1],parts[2]); else if (!item.querySelector('a')) features.push(text);
      else return;
      item.remove();
    });
    source.querySelectorAll('ul,ol').forEach(list => { if (!clean(list.textContent)) list.remove(); });
    source.querySelectorAll('div').forEach(wrapper => wrapper.replaceWith(...wrapper.childNodes));
    source.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(title => {
      const text = clean(title.textContent);
      if (/^(product (details|description|documents|videos)|description|key features|features|specifications|technical (details|specifications)|downloads)$/i.test(text) || !title.nextElementSibling || /^H[1-6]$/.test(title.nextElementSibling.tagName)) title.remove();
    });
    // Normalise supplier paragraphs into the same sections used for Anvil.
    if (owner?.dataset.vendor?.toLowerCase() === 'rock fall') {
      source.querySelectorAll('a').forEach(anchor => { if (/^view additional information$/i.test(clean(anchor.textContent))) anchor.remove(); });
      source.querySelectorAll('p').forEach(paragraph => {
        const label = paragraph.querySelector('strong,b');
        if (!label || paragraph.firstElementChild !== label) return;
        const key = clean(label.textContent).replace(/:$/,'');
        if (!clean(label.textContent).endsWith(':') || key.length > 65) return;
        const value = clean(paragraph.textContent).slice(clean(label.textContent).length).trim();
        if (!value) return;
        if (/^(upper material|eyelets|zips|webbing and trims|laces|thread|tongue.*|collar.*|footbed|lining|scuff cap|kick protector|outsole|digging plate|protective.*|branded tongue label|packaging)$/i.test(key)) facts.set(key,value);
        else features.push(key + ': ' + value);
        paragraph.remove();
      });
    }
    source.querySelectorAll('p').forEach(paragraph => { if (!clean(paragraph.textContent) && !paragraph.querySelector('img')) paragraph.remove(); });
    if (owner?.dataset.vendor?.toLowerCase() === 'rock fall' && Number(owner.querySelector('[data-ny-native-price]')?.dataset.gross) > 0) facts.delete('Price scope');
    const output = make('div','ny-product-information');
    if (record.overview || clean(source.textContent) || source.querySelector('img')) {
      const overview = make('section','ny-info-overview'); heading(overview,'Overview');
      if (record.overview) overview.append(make('p','',record.overview));
      else overview.append(...source.childNodes);
      output.append(overview);
    }
    if (facts.size) {
      const section = make('section','ny-info-section'); heading(section,'Specifications at a glance');
      const grid = make('dl','ny-specification-grid');
      facts.forEach((value,key) => {
        const item = make('div','ny-specification-item');
        item.append(make('dt','',key),make('dd','',clean(value)));grid.append(item);
      });
      section.append(grid);output.append(section);
      owner?.querySelector('.ny-visible-specifications')?.setAttribute('hidden','');
    }
    const seen = new Set();
    const uniqueFeatures = features.filter(text => { const key=text.toLocaleLowerCase(); if(seen.has(key))return false;seen.add(key);return true; });
    if (uniqueFeatures.length) {
      const section = make('section','ny-info-section');heading(section,'Features & materials');
      const grid = make('ul','ny-benefit-grid');
      uniqueFeatures.forEach(text => { const item=make('li','ny-benefit-card');item.append(make('span','ny-benefit-mark','✓'),make('p','',text));grid.append(item); });
      grid.querySelectorAll('.ny-benefit-mark').forEach(mark=>mark.setAttribute('aria-hidden','true'));
      section.append(grid);output.append(section);
    }
    if (videos.length) {
      const section = make('section','ny-info-section ny-information-videos');heading(section,'See the product in use');
      const grid=make('div','ny-product-video-grid');
      videos.forEach(({node,title})=>{const figure=make('figure','ny-product-video');node.removeAttribute('style');if(node.tagName==='VIDEO'){node.controls=true;node.preload='metadata';}figure.append(node);if(title)figure.append(make('figcaption','',title));grid.append(figure);});
      section.append(grid);output.append(section);
    }
    if (documents.length) {
      const section=make('section','ny-info-section ny-local-documents');heading(section,'Product documents');
      documents.forEach(anchor=>{anchor.removeAttribute('target');section.append(anchor);});output.append(section);
    }
    if (notes.length) {
      const section=make('aside','ny-order-note');heading(section,'Ordering & delivery');
      [...new Set(notes)].forEach(text=>section.append(make('p','',text)));output.append(section);
    }
    description.replaceChildren(output);
    description.dataset.nyDetailsRendered = 'true';
    if (!output.children.length) description.closest('.ny-product-details-section')?.setAttribute('hidden','');
  };
  const organise = () => document.querySelectorAll('.ny-description:not([data-ny-details-ready])').forEach(format);
  organise();
  new MutationObserver(organise).observe(document.body,{childList:true,subtree:true});
})();
